import { AxiosPostUrl } from "../../functions/axiosfunctions";

export function sendUpdateReferantData(data: Object, cb = function (reponse: any) {}) {
  // console.log(data)
  AxiosPostUrl(
    "/administration/client/referant/update",
    data,
    (reponse) => {
      if (reponse) {
        cb(reponse);
      } else {
        cb({
          success: false,
          data: {},
          msg: "Erreur survenue !",
        });
      }
    },
    function (reponse) {
      cb({
        success: false,
        data: {},
        msg: "Erreur survenue !",
      });
    }
  );
}
